import { render, staticRenderFns } from "./WriterReportIndexTable.vue?vue&type=template&id=840a5e1a&scoped=true&"
import script from "./WriterReportIndexTable.vue?vue&type=script&lang=js&"
export * from "./WriterReportIndexTable.vue?vue&type=script&lang=js&"
import style0 from "./WriterReportIndexTable.vue?vue&type=style&index=0&id=840a5e1a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840a5e1a",
  null
  
)

export default component.exports